import { render, staticRenderFns } from "./Generate.vue?vue&type=template&id=e38a7b6a&scoped=true&"
import script from "./Generate.vue?vue&type=script&lang=js&"
export * from "./Generate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38a7b6a",
  null
  
)

export default component.exports